import { render } from "./Clients.vue?vue&type=template&id=343980f4"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"
script.render = render

export default script